/*
League display modes that mirror LeagueDisplayModes enum on the backend
**/
export enum LeagueDisplayModes {
  SIMPLE = 'SIMPLE',
  DETAILED = 'DETAILED',
}

export enum LeagueTabs {
  LEADERBOARD = 'leaderboard',
  DETAILS = 'details',
  DISCUSSION = 'discussion',
}

/**
 * The id of the main league
 * TODO - This needs to be kept up to date when the main league changes
 */
export const MAIN_LEAGUE_ID = 'e0cedad3-31f5-4d5b-90f1-18f2861c84da';

/**
 * The id of the main league
 * TODO - This needs to be kept up to date when the main league changes
 */
export const DEFAULT_LEAGUE_REGULATION_URI = 'regles-de-concours';
